import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetFeedV3Request } from './get-feed-v3-request';
import type { IGetFeedV3Response } from './get-feed-v3-response';
import { getFeedV3ResponseSchema } from './get-feed-v3-response';

export async function getFeedV3Api(
  params: IGetFeedV3Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetFeedV3Response>> {
  const query: Record<string, string> = { type: params.type };
  if (params.cursor) {
    query.cursor = params.cursor;
  }
  return getRequest<IGetFeedV3Response>({
    path: '/feed/v3',
    schema: getFeedV3ResponseSchema,
    options: {
      ...options,
      params: query,
    },
  });
}
